import React from 'react';
import { InfoWindow as VisGlInfoWindow } from '@vis.gl/react-google-maps';
export const InfoWindow = ({ position, onClose, pixelOffset, children, }) => {
    return (React.createElement(VisGlInfoWindow, { position: position, onCloseClick: onClose, pixelOffset: pixelOffset ? [pixelOffset.width, pixelOffset.height] : undefined }, children));
};
